module.exports = __webpack_public_path__ + "img/foot3.66b42ad1.png";